import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import {
    LOGOUT,
    HOME_PAGE_UNLOADED
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.settings,
    currentUser: state.common.currentUser,
    fullName: state.common.currentUserFullName
});

const mapDispatchToProps = dispatch => ({
    onClickLogout: () => dispatch({ type: LOGOUT }),
    onUnload: () => dispatch({ type: HOME_PAGE_UNLOADED })
});

class UserMenu extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            modal: false
        };
        this.toggleModel = this.toggleModel.bind(this);
        this.clickLogout = () => ev => this.props.onClickLogout();
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    toggleModel() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <Dropdown nav className="d-md-down-none" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle nav>
                        <img src="https://eppi-centre.github.io/ER5/img/avatars/blank.jpg" className="img-avatar" alt="admin@bootstrapmaster.com" />
                        <span className="d-md-down-none mr-2">{this.props.fullName}</span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-lg" right>
                        <DropdownItem tag={Link} to="/current-user-profile"><i className="fa fa-user"></i> Edit Profile</DropdownItem>
                        <DropdownItem onClick={this.clickLogout()}><i className="fa fa-sign-out"></i> Logout</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(UserMenu));


// WEBPACK FOOTER //
// ./src/containers/menus/UserMenu.js